import React from "react";
import { motion } from "framer-motion";
import Slider from "react-slick";
import { ChevronLeft, ChevronRight } from "lucide-react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Import PDF dari src/assets
import certificate1 from "../assets/certificate1.pdf";
import certificate2 from "../assets/certificate2.pdf";
import certificate3 from "../assets/certificate3.pdf";
import certificate4 from "../assets/certificate4.pdf";
import certificate5 from "../assets/certificate5.pdf";
import certificate6 from "../assets/certificate6.pdf";
import certificate7 from "../assets/certificate7.pdf";
import certificate8 from "../assets/certificate8.pdf";
import certificate9 from "../assets/certificate9.pdf";

const certificates = [
  { pdf: certificate1, title: "ITS - JavaScript" },
  { pdf: certificate2, title: "ITS - Databases" },
  { pdf: certificate3, title: "ETS - TOEIC" },
  { pdf: certificate4, title: "MOS - Excel 2016" },
  { pdf: certificate5, title: "Oracle - Java Programming" },
  { pdf: certificate6, title: "CISCO - IT Essentials" },
  { pdf: certificate7, title: "Google - Fundamental Digital Marketing" },
  { pdf: certificate8, title: "BNSP - Junior Graphic Designer" },
  { pdf: certificate9, title: "BNSP - Electronics Engineering Technician" },
];

const CustomPrevArrow = ({ onClick }) => (
  <button
    onClick={onClick}
    className="absolute -left-4 md:-left-12 top-1/2 -translate-y-1/2 z-10 
               bg-surface/80 hover:bg-surface border border-white/10
               p-3 rounded-full shadow-lg transition-all duration-300 backdrop-blur-sm group"
  >
    <ChevronLeft className="w-5 h-5 text-muted group-hover:text-primary transition-colors" />
  </button>
);

const CustomNextArrow = ({ onClick }) => (
  <button
    onClick={onClick}
    className="absolute -right-4 md:-right-12 top-1/2 -translate-y-1/2 z-10 
               bg-surface/80 hover:bg-surface border border-white/10
               p-3 rounded-full shadow-lg transition-all duration-300 backdrop-blur-sm group"
  >
    <ChevronRight className="w-5 h-5 text-muted group-hover:text-primary transition-colors" />
  </button>
);

export default function Certificates() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: true,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
    appendDots: (dots) => (
      <div>
        <ul className="flex justify-center gap-3 mt-8"> {dots} </ul>
      </div>
    ),
    customPaging: () => (
      <div className="w-2.5 h-2.5 rounded-full bg-white/20 hover:bg-white/50 transition-colors" />
    ),
  };

  return (
    <section id="certificates" className="py-24 px-6 md:px-20 bg-background text-primary relative">
      <div className="max-w-5xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="mb-16"
        >
          <h2 className="text-sm font-semibold tracking-widest text-muted uppercase mb-2">04. Recognition</h2>
          <div className="w-12 h-1 bg-accent/50 rounded-full mb-8"></div>
          <h3 className="text-3xl md:text-4xl font-bold leading-tight tracking-tight">
            Licenses & <span className="text-accent font-medium">Certifications</span>.
          </h3>
        </motion.div>

        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-50px" }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="relative px-4"
        >
          <Slider {...settings}>
            {certificates.map((cert, index) => (
              <div key={index} className="outline-none">
                <div className="flex flex-col items-center text-center px-4">
                  <h4 className="text-xl font-medium mb-8 text-primary/90">
                    {cert.title}
                  </h4>
                  <div className="w-full flex justify-center">
                    {cert.pdf ? (
                      <div className="relative group rounded-2xl overflow-hidden border border-white/10 shadow-2xl bg-surface/50 p-2 backdrop-blur-sm">
                        <iframe
                          src={`${cert.pdf}#toolbar=0&navpanes=0&scrollbar=0`}
                          title={cert.title}
                          className="w-[80vw] max-w-[800px] h-[50vh] min-h-[400px] rounded-xl bg-white"
                        />
                      </div>
                    ) : (
                      <p className="text-muted">PDF not available</p>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </motion.div>
      </div>
      
      <style jsx global>{`
        .slick-dots li.slick-active div {
          background-color: #ffffff;
          transform: scale(1.2);
        }
      `}</style>
    </section>
  );
}
